import React, { useState, useEffect } from "react";
import "./App.css";
import { useRoutes } from "react-router-dom";
import routes from "./routes";
import SplashScreen from "./Pages/SplashScreen/SplashScreen";

export default function App() {
  const router = useRoutes(routes);
  const [showSplashScreen, setShowSplashScreen] = useState(true)

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSplashScreen(false)
        }, 1000)

        return () => clearTimeout(timer)
    }, [])

  return (
    <>
      {showSplashScreen && <SplashScreen />}
      {!showSplashScreen && router}
    </>
  );
}
